import React from "react";

/* Two-line proverb overlay for home banners — re-animates whenever the proverb changes */
export function ProverbText({ proverb, label, rtl }) {
  if (!proverb) return null;
  const tag = proverb.source || label;
  return (
    <div key={proverb.line1} className={`rl-proverb-in max-w-[78%] ${rtl ? "text-right ml-auto" : ""}`} data-testid="banner-proverb" dir={rtl ? "rtl" : "ltr"}>
      {tag && <span className="rl-gold-bg text-[9px] font-bold px-2 py-0.5 rounded-full w-fit mb-1.5 inline-block tracking-wide" data-testid="banner-proverb-tag">{proverb.source ? `❝ ${proverb.source}` : tag}</span>}
      <div className="font-display font-black text-white text-base sm:text-lg leading-snug drop-shadow-[0_2px_6px_rgba(0,0,0,.7)]" data-testid="banner-proverb-line1">{proverb.line1}</div>
      <div className="text-amber-200 text-sm font-semibold leading-snug mt-0.5 drop-shadow-[0_1px_4px_rgba(0,0,0,.7)] rl-proverb-in-2" data-testid="banner-proverb-line2">{proverb.line2}</div>
    </div>
  );
}
